import React from 'react'

export const AppBarContext = React.createContext<{content: React.ReactNode, setContent: (content: React.ReactNode) => void}>({
  content: undefined,
  setContent: undefined,
})
